module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.className,
    on: {
      "click": _vm.onHourClick
    }
  }, [_vm._v(" \n  " + _vm._s(_vm.value) + "\n  "), _c('div', {
    staticClass: "dots"
  }, [(_vm.hasAdio) ? _c('div', {
    staticClass: "has-adio-h"
  }) : _vm._e(), _vm._v(" "), (_vm.hasVideo) ? _c('div', {
    staticClass: "has-video-h"
  }) : _vm._e(), _vm._v(" "), (_vm.hasWeather) ? _c('div', {
    staticClass: "has-weather-h"
  }) : _vm._e(), _vm._v(" "), (_vm.hasAudio) ? _c('div', {
    staticClass: "has-audio-h"
  }) : _vm._e(), _vm._v(" "), (_vm.hasNoise) ? _c('div', {
    staticClass: "has-noise-h"
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6753fa8e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/CalendarHour.vue
// module id = 463
// module chunks = 1